"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Koje je mjerodavno pravo za rješavanje sporova?",
  answer: "Svi sporovi koji proizlaze iz korištenja naših usluga ili su s njima povezani rješavat će se u skladu s važećim zakonima Republike Hrvatske. Primjena međunarodnih konvencija o prodaji robe izričito je isključena."
}, {
  question: "Koji je sud nadležan u slučaju pravnog spora?",
  answer: "U slučaju da spor nije moguće riješiti mirnim putem, ugovara se isključiva nadležnost stvarno nadležnog suda u Zagrebu. Za potrošače se primjenjuju zakonske odredbe o nadležnosti prema njihovom prebivalištu."
}, {
  question: "Postoji li mogućnost izvansudskog rješavanja sporova?",
  answer: "Da, potičemo mirno rješavanje sporova putem mirenja ili arbitraže. Korisnici se također mogu obratiti platformi Europske komisije za online rješavanje sporova (ORS) kako bi pokušali postići dogovor bez odlaska na sud."
}, {
  question: "Koji je postupak za podnošenje prigovora?",
  answer: "Prigovore možete uputiti pisanim putem na našu službenu e-mail adresu ili poštom na adresu sjedišta tvrtke. Obvezujemo se odgovoriti na svaki zaprimljeni prigovor u zakonskom roku od 15 dana od dana primitka."
}, {
  question: "Primjenjuju li se posebne arbitražne klauzule?",
  answer: "Za poslovne korisnike (B2B), ugovori mogu sadržavati specifične arbitražne klauzule koje predviđaju rješavanje sporova pri Stalnom izbranom sudištu Hrvatske gospodarske komore, ovisno o vrijednosti predmeta spora."
}];
export default function Faq() {
  return <section data-section-id="255570" id="rješavanje-sporova" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            Rješavanje sporova
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Informacije o pravnim procedurama, nadležnosti sudova i načinima rješavanja prigovora.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
              <AccordionTrigger className="text-left text-base md:text-lg font-semibold font-default text-foreground hover:text-primary transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed font-default">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}